import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('../features/public-pages/public-page.module').then(m => m.PublicPageModule)
    },
    {
        path: 'portal',
        loadChildren: () => import('../features/supplier-portal-pages/navigation-parent-template.module')
            .then(m => m.NavigationParentTemplateModule),
    },
    {
        path: '**', redirectTo: '/not-found'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { 
        enableTracing: false,
        paramsInheritanceStrategy: 'always',
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
